﻿import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

const state = {
    addresslookup: {
        suggestions: [],
        failure: false,
        selectedAddress: {},
        query: '',
    },
    products: {
        beginProductSearch: false,
        available: [],
        failure: false,
        isDoneSearching: false,
        selectedProduct: '',
        selectedVariant: '',
        selectedNumberOfVas:-1,
        speedUp: -1,
        speedDown: -1,
        blockId: ''
    },
    vas: {
        selectedVas: [],
        maxNumberOfVas: 0,
        nameOfLimitVas: '',
        showSelectionModal: false,
        showLimitModal: false,
    },
    price: '',
    minimumPriceForBindingPeriod: '',
    installationFeeCode: -1,
    activationFeeCode: -1,
    paymentFeeCode: -1,
    vasLessAllowed: true,
    alertModals: {
        showAddressMissingModal: false,
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
